import { Button, Menu } from '@cinesend/ui-kit'
import { DotsThreeVertical } from '@phosphor-icons/react'

const RowMenu = ({ label, items }) => {
  if (!items?.length) return null

  return (
    <Menu
      trigger={
        <Button variant='ghost' iconOnly leadingIcon={<DotsThreeVertical size={20} weight='regular' />}>
          {label}
        </Button>
      }
      items={items}
    />
  )
}

export default RowMenu
